export const CTWA_APP_ID = "871402164056162";
export const EMBEDDED_FB_APP_ID = "1100908887049211";
export const EMBEDDED_INSTA_APP_ID = "851603469430675";
export const EMBEDDED_INSTA_APP_ID_DEV = "1202540277234810";
export const EMBEDDED_INSTA_APP_ID_HAPTIK = "385559113626269";
